// feat_347 — Tab "Permisos" de /Settings.
// feat_351 — primer tab restyleado con el PATRÓN VISUAL CANÓNICO. Es la
// REFERENCIA para los 7 tabs que faltan: mirá `../components/SettingsPattern.js`
// y la sección "Patrón visual de los tabs de /Settings" de CLAUDE.md.
//
// 🔴 REGLA #1 DE ESTA PANTALLA: los 8 TabPanel quedan SIEMPRE MONTADOS (el shell
// los oculta con `hidden`, nunca los desmonta). 26 campos de texto guardan con
// `onBlur`; si al cambiar de tab React desmontara el input, el onBlur NO dispara
// y el usuario pierde lo tipeado sin ningún aviso. NO convertir esto en render
// condicional ni en lazy. Este tab no tiene campos de texto, pero el patrón que
// define SÍ se aplica a tabs que los tienen: nada de Collapse/Accordion que
// desmonte contenido.
//
// Todo el estado vive en el padre (`Settings/index.js`) y llega por `ctx`.
// La lógica de guardado es la MISMA de siempre: `saveSetting(key, "enabled"|"disabled")`
// en el onChange, con el set optimista antes. feat_351 no tocó ni la key ni los
// valores ni el gate de perfil.

import React from "react";

import { i18n } from "../../../translate/i18n.js";
import {
	TabHeader,
	SettingsCard,
	SectionHeader,
	ToggleRow,
} from "../components/SettingsPattern";

const TabPermisos = ({ ctx }) => {
	const {
		saveSetting,
		userProfile,
		userCanDeleteTicket, setUserCanDeleteTicket,
		userCanDeleteMessage, setUserCanDeleteMessage,
	} = ctx;

	// Gate intacto (feat_347): el tab entero es admin-only, y `tabIsVisible` del
	// shell usa el MISMO criterio para ni siquiera mostrar la pestaña.
	if (userProfile !== "admin") return null;

	return (
		<>
			<TabHeader title={i18n.t("settingsExtra.tabPermisos")} />

			{/* UNA sola Paper para todo el tab: es una única sección temática. */}
			<SettingsCard>
				<SectionHeader
					title={i18n.t("settingsExtra.permisosSectionTitle")}
					description={i18n.t("settingsExtra.permisosSectionHelp")}
				/>

				<ToggleRow
					id="setting-userCanDeleteTicket"
					label={i18n.t("settingsExtra.permisosDeleteChatLabel")}
					help={i18n.t("settingsExtra.permisosDeleteChatHelp")}
					tooltip={i18n.t("settingsExtra.permisosDeleteChatTooltip")}
					checked={userCanDeleteTicket}
					onChange={async (e) => {
						const val = e.target.checked ? "enabled" : "disabled";
						setUserCanDeleteTicket(e.target.checked);
						await saveSetting("userCanDeleteTicket", val);
					}}
				/>

				<ToggleRow
					id="setting-userCanDeleteMessage"
					label={i18n.t("settingsExtra.permisosDeleteMessageLabel")}
					help={i18n.t("settingsExtra.permisosDeleteMessageHelp")}
					tooltip={i18n.t("settingsExtra.permisosDeleteMessageTooltip")}
					checked={userCanDeleteMessage}
					onChange={async (e) => {
						const val = e.target.checked ? "enabled" : "disabled";
						setUserCanDeleteMessage(e.target.checked);
						await saveSetting("userCanDeleteMessage", val);
					}}
				/>
			</SettingsCard>
		</>
	);
};

export default TabPermisos;
